import { ChapterHeading } from "../ChapterHeading";
import { Reveal } from "../motion/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Find your situation",
    text: "Search or scan the relevant category.",
  },
  {
    n: "02",
    title: "Pick your tone",
    text: "Choose Warm, Balanced or Firm.",
  },
  {
    n: "03",
    title: "Customize",
    text: "Replace the bracketed details with the facts of your situation.",
  },
  {
    n: "04",
    title: "Say it",
    text: "Copy, send, or use it to start the conversation.",
  },
];

export function HowItWorks() {
  return (
    <section id="how-it-works" className="py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <ChapterHeading
          index="03"
          eyebrow="How it works"
          title={
            <>
              From “I don't know how to say this” to ready in{" "}
              <em className="font-normal">under two minutes.</em>
            </>
          }
        />
        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-xl border border-line bg-line sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08} className="h-full">
              <div className="flex h-full flex-col bg-paper p-7">
                <span className="font-display text-4xl font-light text-faint/70">
                  {s.n}
                </span>
                <p className="mt-8 font-medium text-ink">{s.title}</p>
                <p className="mt-2 text-sm leading-relaxed text-smoke">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
